import React from 'react';
import { graphql } from 'gatsby';
import { useMixpanel } from 'gatsby-plugin-mixpanel';
import Pancake from './Pancake';

import Button from '../Button';

import GitHubIcon from '../../icons/GitHub';
import GitLabIcon from '../../icons/GitLab';

import './TrySourceControlProvider.scss';

const PreFooter = (props) => {
  const { title, theme } = props;

  const TrySourceControlProviderTitle =
    title ||
    'Want to see it in action? Try it with your favorite source control provider:';

  const mixpanel = useMixpanel();

  return (
    <Pancake className="TrySourceControlProvider" theme={theme}>
      <h2 className="TrySourceControlProviderTitle">
        {TrySourceControlProviderTitle}
      </h2>
      <div className="PreFooterButtons">
        <Button
          className="theme-github"
          to="https://www.okteto.com/docs/previews/using-github-actions/"
          external
          onClick={() =>
            mixpanel.track('Click Try Github Preview Environments')
          }
        >
          <Button.Logo>
            <GitHubIcon />
          </Button.Logo>
          Try it with GitHub
        </Button>

        <Button
          className="theme-gitlab"
          to="https://www.okteto.com/docs/previews/using-gitlab-cicd/"
          external
          onClick={() =>
            mixpanel.track('Click Try Gitlab Preview Environments')
          }
        >
          <Button.Logo>
            <GitLabIcon />
          </Button.Logo>
          Try it with Gitlab
        </Button>
      </div>
    </Pancake>
  );
};

export const query = graphql`
  fragment SanityTrySourceControlProvider on SanityTrySourceControlProvider {
    _key
    _type
    title
    theme
  }
`;

export default PreFooter;
